import { Component } from '@angular/core';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { UserRole } from 'src/app/models/enums';
  
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginDTO: any;
  OTP = false;
  loader = false;
  Email: string;
  showPassword: boolean = false;
  constructor(
    public loginService: LoginService, 
    public router: Router,
    private cookieService: CookieService,
    private toastr:ToastrService  
  ) {
    // Clear cookies on login component load
    sessionStorage.setItem("Login", "1");
    this.cookieService.delete('orderCookie');
    this.cookieService.delete('customerObject');
    this.cookieService.delete('orderButtonCookie');
  }

  async Login(Username: string, Password: string) {
    
    if(Username==""|| Username==undefined || Username==null){
      this.toastr.warning("Username cannot be empty","Validation")
      return
    }
    if(Password==""|| Password==undefined || Password==null){
      this.toastr.warning("Password cannot be empty","Validation")
      return
    }
    this.loader = true;
    this.Email = Username;
    this.loginDTO = {
      UserName: Username,
      Password: Password
    };

    console.log(this.loginDTO);
    await this.loginService.Login(this.loginDTO).subscribe({
      next: (r:any) => {
        console.log(r)
        
        if (r != null) {
          this.OTP = true;
          this.loader = false;
          this.loginService.setLoggedInStatus(true); // Set login status in service
        }
        if (r.includes('Login Successfull')) {
        console.log("Login Successfull");
        }

      },
      error: e => {
        this.loader=false
        console.log(e)
        if(e.error.text === "Login Successfull" && e.status ===200) {
          this.OTP = true;
          this.loader = false;
          this.loginService.setLoggedInStatus(true);
        }
        
        // Swal.fire("Login Failed", "Invalid username or password", "error");
        else if(e.error.message){
          this.toastr.error('Oops!', e.error.message);
        }
        else{
          this.toastr.error('Oops!', "Something went wrong");
        }
      }
    });
  }


  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }


  verifyOTP(OTP: string) {
    if(OTP==null || OTP=="" || OTP==undefined){
      this.toastr.warning("OTP is required","Validation")
      return
    }
    this.loader = true;
    this.loginService.VerifyOtp(OTP, this.Email).subscribe({
      next: (res: any) => {
        console.log(res);

        // Store the necessary user information in localStorage
        localStorage.setItem("Token", res.token);
        localStorage.setItem("UserId", res.user.id);
        localStorage.setItem("RoleType", res.user.roleType);
        localStorage.setItem("RetailerId", res.user.retailerId);
        localStorage.setItem("isTestMode", res.user.isTestMode);

        // Set login status in localStorage
        localStorage.setItem('isLoggedIn', 'true');

        this.loader = false;
        console.log(res.user.roleType)

        if(res.user.roleType === UserRole.Retailer){
           window.location.href=environment.appBaseUrl+environment.appName+'retailer-home';
          // this.router.navigate(['/retailer-home'],{replaceUrl:true});
        }
        else{
          window.location.href=environment.appBaseUrl+ environment.appName+'dashboard';
          // this.router.navigate(['/dashboard'],{replaceUrl:true});
        }
        // Navigate to dashboard
        // this.router.navigate(['/dashboard'], { replaceUrl: true, skipLocationChange: true });
        // window.location.href=environment.BaseUrl+'/dashboard';
      //  window.location.href='/PridAppLive/dashboard';
       //window.location.href='/Pridapp/dashboard';
        //window.location.href='/dashboard';
      },
      error: e => {
        this.loader = false;
        // Swal.fire(e.error.title, "Invalid", "error");
        if(e.error.message){
          this.toastr.error('Oops!', e.error.message);
        }
        else{
          this.toastr.error('Oops!', "Something went wrong");
        }
      }
    });
  }
}
